module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker (7).07942ec3.gif";